import * as React from "react";
import PropTypes from "prop-types";

import MuiDialogActions from "@mui/material/DialogActions";
import Button from "ui/Button";

function DialogActions(props) {
  const {
    submitButtonName = "Submit",
    closeButtonName = "Cancel",
    variant = "primary",
    disableSubmit = false,
    isLoading = false,
    preLoading = false,
    onClose,
    renderActionsFunc,
    ariaLabelledby = "dialog",
  } = props;

  const renderActionContent = () => {
    if (renderActionsFunc) {
      return renderActionsFunc(onClose, isLoading, preLoading);
    }
    return (
      <>
        <Button
          id={`${ariaLabelledby.toLowerCase()}_cancel`}
          variant="text"
          onClick={onClose}
          color={variant}
        >
          {closeButtonName}
        </Button>
        <Button
          id={`${ariaLabelledby.toLowerCase()}_submit`}
          loading={isLoading}
          type="submit"
          color={variant}
          disabled={disableSubmit || preLoading}
        >
          {submitButtonName}
        </Button>
      </>
    );
  };

  return <MuiDialogActions>{renderActionContent()}</MuiDialogActions>;
}

export const DialogActionsPropTypes = {
  onClose: PropTypes.func.isRequired,
  submitButtonName: PropTypes.string,
  closeButtonName: PropTypes.string,
  variant: PropTypes.oneOf(["primary", "error"]),
  disableSubmit: PropTypes.bool,
  isLoading: PropTypes.bool,
  preLoading: PropTypes.bool,
  renderActionsFunc: PropTypes.func,
  ariaLabelledby: PropTypes.string,
};

DialogActions.propTypes = DialogActionsPropTypes;

export default DialogActions;
